import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var Like = t.type({
  id: t.string,
  createdAt: nullable(t.string),
  member: t.type({
    id: t.string,
    name: t.string,
    title: nullable(t.string),
    avatarUrl: nullable(t.string)
  })
});
export var Likes = t.type({
  edges: nullable(t.array(t.type({
    cursor: t.string,
    node: Like
  }))),
  pageInfo: t.type({
    hasNextPage: t["boolean"],
    endCursor: t.string
  }),
  totalCount: t.number
});
export var LikeTargetType = t.keyof({
  ChallengeResponse: null,
  ChallengeResponseComment: null
});
export var LikeTypename = t.keyof({
  PublicResponse: null,
  PublicResponseComment: null
});
export var NodeWithLike = t.type({
  __typename: LikeTypename,
  id: t.string,
  likes: nullable(Likes),
  currentUserLike: nullable(t.type({
    id: t.string
  }))
});
export var LikeOutput = t.type({
  like: t.union([t.type({
    __typename: t.literal('LikeResult'),
    result: Like
  }), t.type({
    __typename: t.literal('LikeErrors'),
    errors: t.array(t.type({
      message: t.string
    }))
  })])
});
export var UnlikeOutput = t.type({
  unlike: t.union([t.type({
    __typename: t.literal('UnlikeResult'),
    result: t.string
  }), t.type({
    __typename: t.literal('UnlikeErrors'),
    errors: t.array(t.type({
      message: t.string
    }))
  })])
});